import { Modal } from 'antd';

type DeleteModalProps = {
    open: boolean;
    entityName?: string | null;
    entityType?: 'project' | 'objection' | 'user' | 'support-ticket' | 'script';
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
};

const getEntityTypeLabel = (type?: 'project' | 'objection' | 'user' | 'support-ticket' | 'script'): string => {
    switch (type) {
        case 'project':
            return 'проект';
        case 'objection':
            return 'заперечення';
        case 'user':
            return 'користувача';
        case 'support-ticket':
            return 'запит на підтримку';
        case 'script':
            return 'скрипт';
        default:
            return 'запис';
    }
};

export const DeleteProjectModal = ({
    open,
    entityName,
    entityType = 'project',
    onConfirm,
    onCancel,
    loading = false,
}: DeleteModalProps) => {
    const entityLabel = getEntityTypeLabel(entityType);

    return (
        <Modal
            title="Підтвердження видалення"
            open={open}
            onOk={onConfirm}
            onCancel={onCancel}
            okText="Видалити"
            cancelText="Скасувати"
            okButtonProps={{ danger: true }}
            confirmLoading={loading}
        >
            <p>
                {`Ви впевнені, що хочете видалити ${entityLabel} "${entityName}"? Цю дію неможливо скасувати.`}
            </p>
        </Modal>
    );
};
